import { CourseProgressTracker } from './state';
// import { ProgressAction } from './state/index.d';
import { UserProgressActionTypes } from './types';
import { normalize } from 'normalizr';
import * as schema from '../../utils/schema';

/* import * as actionTypes from './types';
import ActionType from './types';

 */
export default function courseProgress(state: any = CourseProgressTracker, action: any) {
  let uTrack, cTrack, aTrack, qTrack, mTrack, vTrack, pTrack, courseTrack, cVTrack;
  switch (action.type) {
    case UserProgressActionTypes.USER_PROGRESS_TRACK:
      uTrack = normalize(action.payload.unitTracks || [], [schema.unitTrack]);
      mTrack = normalize(action.payload.moduleTracks || [], [schema.moduleTrack]);
      cTrack = normalize(action.payload.chapterTracks || [], [schema.chapterTrack]);
      aTrack = normalize(action.payload.assignmentTracks || [], [schema.assignmentTrack]);
      qTrack = normalize(action.payload.quizTracks || [], [schema.quizTrack]);
      vTrack = normalize(action.payload.videoTracks || [], [schema.videoTrack]);
      pTrack = normalize(action.payload.projectTracks || [], [schema.projectTrack]);
      courseTrack = normalize(action.payload.courseTracks || [], [schema.courseTrack]);
      cVTrack = normalize(action.payload.chapterVideoTracks || [], [schema.chapterVideoTracks]);

      return {
        ...state,
        generateProgramCertificate: action.payload.generateProgramCertificate || false,
        certificateGeneratedCourses: action.payload.certificateGeneratedCourses || [],
        unitTracks: uTrack.entities.unitTracks || {},
        chapterTracks: cTrack.entities.chapterTracks || {},
        moduleTracks: mTrack.entities.modulesTracks || {},
        assignmentTracks: aTrack.entities.assignmentTracks || {},
        quizTracks: qTrack.entities.quizTracks || {},
        videoTracks: vTrack.entities.videoTracks || {},
        projectTracks: pTrack.entities.projectTracks || {},
        courseTracks: courseTrack.entities.courseTracks || {},
        chapterVideoTracks: cVTrack.entities.chapterVideoTracks || {}
      };

    case UserProgressActionTypes.CLEAR_PROGRESS_FETCH:
      return {
        ...state,
        generateProgramCertificate: false,
        certificateGeneratedCourses: [],
        chapterVideoTracks: {},
        moduleTracks: {},
        unitTracks: {},
        chapterTracks: {},
        assignmentTracks: {},
        quizTracks: {},
        videoTracks: {},
        projectTracks: {},
        courseTracks: {}
      }

    default:
      return state;
  }
}
